module.exports = __webpack_public_path__ + "img/0e7da62.png";